import React from 'react';
import BaseComponent from "../../../../../../../base/BaseComponent";
import { Cascader } from "antd";
export default class Sta_Cascader extends BaseComponent {
  static defaultProps = {};
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {
      result: [], // 初始化为空数组
      value:[]
    }
  }

  componentWillMount() {
  }

  componentDidMount() {
   
    // let { method, url } = this.props.config&&this.props.config.request;
    let { method, url } = this.props.config.request;
    // this.request({
    this.request({
      url,
      method,
      callBack: (res) => {
        const extractedData = this.extractFields([res]);
        this.setState({ result: extractedData }); // 将提取后的数据更新到组件的状态中
      },
      errorCallBack: (e) => {
        console.log(e.toString());
      },
    });
  }

  extractFields = (treeArray) => {
    const result = [];
    treeArray.forEach(node => {
      const newNode = {
        label: node.name,
        value: node.id,
        children: node.child
      };
      if (node.child && node.child.length > 0) {

        newNode.children = this.extractFields(node.child);
      }
      result.push(newNode);
    });

    return result;
  }


  render() {


    const { config, size, onChange, id, labelCode,value } = this.props;
    let btnName = config?.btnName || "btnName";
    let type = config?.type || "primary";
    let clickCall = config?.clickCall;


    // if (value==0) {
    //   this.setState({ value })
    // }
    return (
      <div className={type === 'default' ? 'exportBtn' : ''}>
        {/* <Cascader
         options={result}
        //  options={this.state.options}
         onChange={onChange} changeOnSelect /> */}
        <Cascader
          options={this.state.result}
          value={value!=0?this.state.value:[value]}
          onChange={(e) => {
            this.setState({
              value: e
            })

            onChange({ labelCode, val: e[e.length - 1] })

          }}
          changeOnSelect
        />
        {/* <Cascader options={this.state.result} onChange={onChange} changeOnSelect /> */}
      </div>
    )
  }

}